import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import { Bookmark, Star } from 'lucide-react'
import Watchlist from '../Watchlist'
import AlphaPicks from '../AlphaPicks'
import { useWatchlistStore } from '../../store/watchlistStore'
import { pageContainerVariants, pageItemVariants } from '../../constants/motionVariants'

type Tab = 'watchlist' | 'alpha'

const WatchlistPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>('watchlist')
  const { loadWatchlist } = useWatchlistStore()

  useEffect(() => {
    loadWatchlist()
  }, [])

  return (
    <motion.div variants={pageContainerVariants} initial="hidden" animate="visible" className="space-y-4">
      <motion.div variants={pageItemVariants} className="card  overflow-hidden">
        {/* Tab bar */}
        <div className="flex border-b border-gray-100 dark:border-gray-700/50">
          <button
            onClick={() => setActiveTab('watchlist')}
            className={`flex items-center gap-2 px-5 py-3.5 text-sm font-medium border-b-2 transition-colors -mb-px ${
              activeTab === 'watchlist'
                ? 'border-indigo-500 text-indigo-600 dark:text-indigo-400'
                : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
            }`}
          >
            <Bookmark className="w-4 h-4" />
            Watchlist
          </button>
          <button
            onClick={() => setActiveTab('alpha')}
            className={`flex items-center gap-2 px-5 py-3.5 text-sm font-medium border-b-2 transition-colors -mb-px ${
              activeTab === 'alpha'
                ? 'border-amber-500 text-amber-600 dark:text-amber-400'
                : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
            }`}
          >
            <Star className="w-4 h-4" />
            Alpha Picks
          </button>
        </div>

        {/* Tab content — both stay mounted to prevent re-fetching on tab switch */}
        <div style={{ display: activeTab === 'watchlist' ? 'block' : 'none' }}>
          <Watchlist />
        </div>
        <div style={{ display: activeTab === 'alpha' ? 'block' : 'none' }}>
          <AlphaPicks />
        </div>
      </motion.div>
    </motion.div>
  )
}

export default WatchlistPage
